<template>
	<div>
		<div v-if="tradable.price.mt == null">{{ __("n.a.") }}</div>
		<div
			v-else-if="
				user &&
				user.type == 'FARMER' &&
				tradable.trade == 'BUY' &&
				tradable.location.mode == 'DAP' &&
				tradable.location.optional_transport &&
				match.price_estimate
			"
		>
			{{ __("Price") }}:
			{{ $cropOptions.formatLocalizedNumber(match.price_estimate) + " €/t" }}
		</div>
		<div v-else-if="tradable.price.type == 'FLAT'">
			{{ __("Flat Price") }}:
			{{ $cropOptions.formatLocalizedNumber(tradable.price.mt) }} €/t
		</div>
		<div v-else-if="tradable.price.type == 'INDEXED'">
			{{ __("Premium based") }}: {{ tradable.price.basis > 0 ? "+" : ""
			}}{{ $cropOptions.formatLocalizedNumber(tradable.price.basis) }} €/t
			{{
				tradable.commodityFuture || tradable.commodity_future
					? (tradable.commodityFuture || tradable.commodity_future).name
					: ""
			}}
		</div>
		<div v-else-if="tradable.price.type == 'BASIS'">
			{{ __("Premium") }}
			{{ $cropOptions.formatLocalizedNumber(tradable.price.basis) }} €/t
			{{ tradable.commodityFuture.name }})
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
		user: {
			type: Object,
			required: false,
		},
		match: {
			type: Object,
			required: false,
		},
	},
};
</script>
